import { toast } from "react-toastify";
import { put, call, delay } from "redux-saga/effects";
import { GET, GET_SCRIPT, PUT,POST } from "../../../../services/api";

export function* getOrderData(action) {
  console.log("getOrderData action.payload",action.payload)
  yield put({ type: "YOUR_MEDIAS_REQUEST", });
  //yield delay(3000)
  const result = yield call(GET_SCRIPT, { endpoint: `/scripts_store/${action.payload.order_id}/${action.payload.user_id}/${action.payload.store_id}`, });
  if (result.error === true) {

    yield put({
      type: "YOUR_MEDIAS_ERROR", payload: {
        status: result.data.response?.status ?? null,
        description: result.data.response?.data?.description ?? null,
      }
    });
  } else {
    yield put({ type: "YOUR_MEDIAS_SUCCESS", payload: result.data });
  }
}



export function* getLoginOrderData(action) {
  console.log("getLoginOrderData action.payload",action.payload)
  yield put({ type: "LOGIN_ORDER_REQUEST", });
  //yield delay(3000)
  const result = yield call(POST, { endpoint: `/sales/customer`, data: { email: action.payload.email, orderNumber: action.payload.orderNumber, platform: action.payload.platform, userToken: action.payload.userToken } });
  if (result === false || result.error === true) {

    yield put({
      type: "LOGIN_ORDER_ERROR", payload: {
        status: result?.data?.response?.status ?? null,
        description: result?.data?.response?.data?.description ?? null,
      }
    });
  } else {
    yield put({ type: "LOGIN_ORDER_SUCCESS", payload: result.data });
    localStorage.setItem("loginOrder@dijital", true)
  }
}
